export const css = {
    root: '_35f0ShO_',
    scoreContainer: '_1qZHQneX',
    title: '_37Dqlfi2',
    wrapper: '_2zC82HQr',
    domain: '_2BMVkmHH',
    field: 'HQHlV8NV',
    bar: '_2QdWLnUQ',
    lowScore: '_32YPcoug',
    midScore: '_2zv7MXJW',
    highScore: '_3MEl55TE',
    barZero: '_2nvIe6MX',
    barLow: '_30uxSWvt',
    barMid: '_2qeHzKvh',
    barHigh: '_1VHiZSPX',
    barscore: '_1AHZO3kZ',
    legend: '_3KYQLOE_',
    ' _key': 'certwise-theme/certwise/prepost-viz/progress-viz'
};
export default css;
